import axios, { AxiosResponse } from 'axios'
import {
  ModeloDtoAlteracao,
  ModeloDtoCreate,
  ModeloView,
  ModeloVinculoDtoAdd,
  ModeloVinculoDtoRemove,
  PageResponseModeloList,
} from './_models'
import { TipoAnexoList } from 'app/modules/apps/atendimento/core/_models'

const API_URL = process.env.REACT_APP_API_URL
const ANEXOS_TIPOS_URL = `${API_URL}/anexo/tipos`
const MODELOS_URL = `${API_URL}/modelos`
const MODELOS_VINCULO_URL = `${API_URL}/modelos/vinculo`

/**
 * Busca modelos de documentos
 * @param query string
 * @returns PageResponseModeloList
 */
export const getModelos = (query: string): Promise<PageResponseModeloList> => {
  return axios
    .get(`${MODELOS_URL}?${query}`)
    .then((resp: AxiosResponse<PageResponseModeloList>) => resp.data)
}

/**
 * Busca um modelo de documento
 * @param modeloId Identificador do modelo
 * @returns ModeloView
 */
export const getModeloById = (modeloId: number): Promise<ModeloView> => {
  return axios
    .get(`${MODELOS_URL}/${modeloId}`)
    .then((resp: AxiosResponse<ModeloView>) => resp.data)
}

/**
 * Altera um modelo de documento
 * @param modeloId Identificador do modelo
 * @param data ModeloDtoAlteracao
 * @returns ModeloView
 */
export const updateModelo = (modeloId: number, data: ModeloDtoAlteracao): Promise<ModeloView> => {
  return axios
    .put(`${MODELOS_URL}/${modeloId}`, data)
    .then((resp: AxiosResponse<ModeloView>) => resp.data)
}

/**
 * Remove um modelo de documento
 * @param modeloId Identificador do modelo
 * @returns void
 */
export const deleteModelo = (modeloId: number): Promise<void> => {
  return axios.delete(`${MODELOS_URL}/${modeloId}`)
}

/**
 * Cadastra um modelo de documento
 * @param data ModeloDtoCreate
 * @param pdf File
 * @returns ModeloView
 */
export const createModelo = (data: ModeloDtoCreate, pdf: File): Promise<ModeloView> => {
  const formData = new FormData()
  formData.append('dto', JSON.stringify(data))
  formData.append('file', pdf)

  return axios.post(MODELOS_URL, formData).then((resp: AxiosResponse<ModeloView>) => resp.data)
}

/**
 * Adiciona vinculos em modelo de documento
 * @param idModelo ID do modelo
 * @param data ModeloVinculoDtoAdd
 * @returns ModeloView
 */
export const addVinculosToModelo = (
  idModelo: number,
  data: ModeloVinculoDtoAdd
): Promise<ModeloView> => {
  return axios
    .patch(`${MODELOS_VINCULO_URL}/${idModelo}`, data)
    .then((resp: AxiosResponse<ModeloView>) => resp.data)
}

/**
 * Remove vinculos de modelo de documento
 * @param idModelo ID do modelo
 * @param data ModeloVinculoDtoRemove
 * @returns ModeloView
 */
export const removeVinculosFromModelo = (
  idModelo: number,
  data: ModeloVinculoDtoRemove
): Promise<ModeloView> => {
  return axios
    .delete(`${MODELOS_VINCULO_URL}/${idModelo}`, { data })
    .then((resp: AxiosResponse<ModeloView>) => resp.data)
}

/**
 * Busca todos os tipos de anexo
 * @returns TipoAnexoList[]
 */
export const getTiposAnexos = (): Promise<TipoAnexoList[]> => {
  return axios.get(`${ANEXOS_TIPOS_URL}`).then((resp: AxiosResponse<TipoAnexoList[]>) => resp.data)
}
